import { createSlice } from "@reduxjs/toolkit";
import patientList from "../../../rtk-apis/patients/patientList";

const initialState = {
  status:"",
  result:{},
  msg:"",
  loading:false,
  error:""

};

const patientListSlice = createSlice({
  name: "patientListSlice",
  initialState,
  reducers: {
    closePatientListModal (state:any) { state.status = ""; }
  },
  extraReducers: (builder) => {
    builder
      .addCase(patientList.pending, (state, action) => {
        console.log("Pending")
        state.loading = true;
      })
      .addCase(patientList.fulfilled, (state, { payload }) => {
        console.log("Fulfilled",payload)
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(patientList.rejected, (state, { payload }) => {
        console.log("Rejected")
        state.result = payload;
        state.loading = false;
      });
  },
});

export default patientListSlice.reducer;
export const { closePatientListModal } = patientListSlice.actions;
